import { Button } from 'ui/mobile-ds';
import {
  FLOATING_WIDGET_Z_INDEX,
  IFloatingVariantProps,
} from '../FloatingWidget';
import { CloseFilled, Help } from 'ui/icons';
import { useEffect, useState } from 'react';
import { useFloatingWidgetContext } from '@/context/FloatingWidgetContext';
import { EMessageType } from '@/types';
import { useAppContext } from '@/context/AppContext';
import clsx from 'clsx';
import { getDimensions } from '@/utils';

const SupportCenter = ({
  onTriggerClick,
  isHidden,
  isOpen,
}: IFloatingVariantProps) => {
  const { readyEvents, postMessage } = useFloatingWidgetContext();
  const { xPlumToken } = useAppContext();
  const [bottom, setBottom] = useState(24);

  const isTokenEventReady = readyEvents.has(EMessageType.TOKEN);

  useEffect(() => {
    if (isTokenEventReady && xPlumToken) {
      postMessage(EMessageType.TOKEN, {});
    }
  }, [isTokenEventReady, xPlumToken]);

  useEffect(() => {
    const footerDimensions = getDimensions('claims-footer');
    setBottom(
      footerDimensions?.height > 0 ? footerDimensions?.height + 12 : 24
    );
  }, [isHidden]);

  if (isHidden) {
    return null;
  }

  return (
    <div id="in-app-support-trigger">
      <Button
        style={{
          zIndex: FLOATING_WIDGET_Z_INDEX + 1,
          bottom,
        }}
        className={clsx({
          'fixed right-6 bottom-6 outline-none py-3 px-4 rounded-full text-white text-sm font-medium shadow-md bg-hero-vision-500 hover:bg-hero-vision-500 active:bg-hero-vision-500 focus:bg-hero-vision-500 gap-0':
            true,
        })}
        onClick={onTriggerClick}
      >
        {isOpen ? <CloseFilled color="white" /> : <Help />}
        <p className="ml-2">{isOpen ? 'Close' : 'Help and Support'}</p>
      </Button>
    </div>
  );
};

export default SupportCenter;
